<template>
    <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
              <el-col :lg="12">
                <el-form-item label="職稱:">
            <el-radio-group v-model.number="searchForm.role">
                <el-radio v-for="item in options" :key="item.key" :label="item.label">
                    {{item.name}}
                </el-radio>
            </el-radio-group>
            
            </el-form-item>
           
              </el-col>
              <el-col :lg="12">
               <el-form-item>
                <el-button type="primary" @click="fetchPermission">查詢</el-button>
                
            </el-form-item>
              </el-col>
          </el-row>
          
        </el-form>
        <el-row>
            <el-col :lg="2" :offset="22">
            <el-button type="primary" @click="openDia">新增</el-button>
             <add :diaFormVisble="diaFormVisble" @closeDia="closeDia" />
            </el-col>
        </el-row>
        
        <el-row>
            <el-col :lg="22">
            <el-table :data="permissionList.slice((currentPage-1)*pagesize,currentPage*pagesize)"
            empty-text="暫無數據"
             >
                <el-table-column label="職稱" prop="role">
                <template slot-scope="scope">
                {{scope.row.role == 0 ? '管理者': ''}}
                {{scope.row.role == 1 ? '業務': ''}}
                {{scope.row.role == 2 ? '美容師': ''}}
                </template>
                </el-table-column>
                <el-table-column label="網址" prop="url">
                </el-table-column>
                <el-table-column label="刪除">
                <template slot-scope="scope">
                <el-button type="primary" @click="deletePermission(scope.$index, scope.row)" circle icon="el-icon-delete" ></el-button>
                
                </template>
                </el-table-column>
            </el-table>
                 <el-pagination
        background
        layout="prev, pager, next"
        :total="total1"
        @current-change="current_change"
        >
      </el-pagination>
            </el-col>
        </el-row>
        
        
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import add from './add'
    export default {
        name: 'search',
        components: {
            add
        },
        data() {
            return {
                searchForm: {
                    role: null
                },
                diaFormVisble: false,
                permissionList: [],
                open: false,
                      total1: 0,
                 currentPage:1,
                pagesize: 10,
                options: [
                    {label: 0, name: '管理者', key: 1},
                    {label: 1, name: '業務', key: 2},
                    {label: 2, name: '美容師', key: 3}
                ]
            }
        },
        computed: mapGetters(["getPermissionList", "getPermissionError", "getPermissionMsg"]),
        methods: {
            ...mapActions(["fetchPermissionList", "deletePermission", "addPermission"]),
            async fetchPermission(){
                const data = {
                  role:  this.searchForm.role
                }

               await this.$store.dispatch('fetchPermissionList', data)
                this.permissionList = await this.getPermissionList
                this.total1 = await this.permissionList.length
            },

            async deletePermission(index, row){
                const data = {_key: row._key}
                await this.$store.dispatch('deletePermission', data)
                if(this.getPermissionError == true){
                    this.$notify({
                        title: '失敗',
                        message: this.getPermissionMsg,
                        type: 'error',
                        duration: '4500',
                        position: 'top-right'
                   });
                 }else {
                     this.$notify({
                         title: '成功',
                         message: '刪除權限成功',
                         type: 'info',
                         duration: '4500',
                         position: 'top-right'
                     });
                     
                 }
            },
               openDia(){
                   this.diaFormVisble = true
               },
               closeDia(){
                this.diaFormVisble = false
               },
               current_change: function (currentPage) {
                this.currentPage = currentPage;
            },

           
        },
    }
</script>